import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8d528578"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_s_b"
};
const _hoisted_2 = {
  class: "user_box"
};
import { ref } from "vue";
import { ElTabs, ElTabPane } from "element-plus";
import userItem from "./user-item.vue";
import GroupItem from "./group-chat.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tag_list: {
      type: Array,
      default: () => []
    },
    from: {
      type: String
    },
    show_chat: {
      type: Boolean,
      default: false
    }
  },
  emits: ["set_chart", "set_chart2"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const activeName = ref(1);
    //activeName 为tag_list的第一个
    activeName.value = props.tag_list[0].id;
    const handleClick = (tab, event) => {
      if (activeName.value == 3) {
        emit("set_chart", {});
      } else if (activeName.value == 1) {
        emit("set_chart2", {});
      }
    };
    const emit = __emit;
    const set_actives = item => {
      emit("set_chart", item);
    };
    const set_actives2 = item => {
      emit("set_chart2", item);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElTabs), {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tag_list, (item, index) => {
          return _openBlock(), _createBlock(_unref(ElTabPane), {
            key: index,
            name: item.id,
            label: item.name
          }, null, 8, ["name", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [activeName.value == 1 || activeName.value == 2 ? (_openBlock(), _createBlock(userItem, {
        key: 0,
        activeName: activeName.value,
        onSet_actives: set_actives,
        from: __props.from
      }, null, 8, ["activeName", "from"])) : activeName.value == 3 || activeName.value == 4 ? (_openBlock(), _createBlock(GroupItem, {
        key: 1,
        show_chat: __props.show_chat,
        from: __props.from,
        activeName: activeName.value,
        onSet_actives2: set_actives2
      }, null, 8, ["show_chat", "from", "activeName"])) : _createCommentVNode("", true)])]);
    };
  }
});